import type { TPath } from "./types";

import closeRound from "./icons/closeRound.svg";
import bonusMoney from "./icons/bonusMoney.svg";
import livelib16 from "./icons/livelib16.svg";
import adultContentLogo from "./icons/adultContentLogo.svg";
import congrats from "./icons/congrats.svg";
import envelope from "./icons/envelope.svg";

import masterCard from "./icons/paymentMethods/masterCard.svg";
import masterCardSmall from "./icons/paymentMethods/masterCard-small.svg";
import mir from "./icons/paymentMethods/mir.svg";
import unionPay from "./icons/paymentMethods/unionPay.svg";
import unknown from "./icons/paymentMethods/unknown.svg";
import visa from "./icons/paymentMethods/visa.svg";
import foreignCard from "./icons/paymentMethods/foreignCard.svg";
import sberSpasibo from "./icons/paymentMethods/sberSpasibo.svg";
import payPal from "./icons/paymentMethods/payPal.svg";
import payPalSmall from "./icons/paymentMethods/payPal-small.svg";
import sbp from "./icons/paymentMethods/sbp.svg";

import fb from "./icons/socialNetworks/fb.svg";
import gp from "./icons/socialNetworks/gp.svg";
import ma from "./icons/socialNetworks/ma.svg";
import ok from "./icons/socialNetworks/ok.svg";
import sb from "./icons/socialNetworks/sb.svg";
import tw from "./icons/socialNetworks/tw.svg";
import vk from "./icons/socialNetworks/vk.svg";
import vkid from "./icons/socialNetworks/vkid.svg";
import apple from "./icons/socialNetworks/apple.svg";
import ya from "./icons/socialNetworks/ya.svg";
import yaEng from "./icons/socialNetworks/ya-eng.svg";

import check from "./icons/subscriptionProfits/check.svg";
import discount from "./icons/subscriptionProfits/discount.svg";
import noInternet from "./icons/subscriptionProfits/noInternet.svg";
import star from "./icons/subscriptionProfits/star.svg";
import sync from "./icons/subscriptionProfits/sync.svg";

import chitaiGorod from "./icons/loyalty/chitaiGorod.svg";
import litres from "./icons/loyalty/litres.svg";
import bukvoed from "./icons/loyalty/bukvoed.svg";
import wink from "./icons/loyalty/wink.svg";
import litresSubscribe from "./icons/loyalty/litresSubscribe.svg";

export const svgPathsMap = new Map<keyof TPath, any>([
  [
    "icons",
    {
      adultContentLogo: adultContentLogo,
      closeRound: closeRound,
      bonusMoney: bonusMoney,
      livelib16: livelib16,
      congrats,
      envelope,
    },
  ],
  [
    "socialNetworks",
    {
      "ya-eng": yaEng,
      apple,
      ap: apple,
      ya: ya,
      vk: vk,
      vkid: vkid,
      gp: gp,
      ma: ma,
      sb: sb,
      ok: ok,
      tw: tw,
      fb: fb,
    },
  ],
  [
    "paymentMethods",
    {
      masterCard,
      "masterCard-small": masterCardSmall,
      mir,
      unionPay,
      unknown,
      visa,
      foreignCard,
      sberSpasibo,
      payPal,
      "payPal-small": payPalSmall,
      sbp,
    },
  ],
  [
    "subscriptionProfits",
    {
      star: star,
      discount: discount,
      sync: sync,
      noInternet: noInternet,
      check: check,
    },
  ],
  [
    "loyalty",
    {
      chitaiGorod,
      litres,
      bukvoed,
      wink,
      litresSubscribe,
    },
  ],
]);
